<template>
  <div class="corporation_e">
    <PageContent>
      <StepsV2 type="s3" :step="1" />
      <PanelV2
        type="w6"
        title="Enter your business address"
        @nextClick="commitData"
      >
        <template v-slot:title-solt>
          <BdoProgress total="4" step="2" />
        </template>
        <template v-slot:content-solt>
          <AppForm
            ref="appForm"
            v-model="formData"
            :selectOptions="selectOptions"
          />
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
  import AppForm from "../forms/NewMerchantCorpE.val";
  import {provinceData, cityData} from "../../common-data/config";
  import barangayData from "../../common-data/barangay-data";
  import API from "@/api";
  export default {
    name: 'CorporationE',
    pRouter: 'CorporationD',
    components: {
      AppForm,
    },
    data() {
      return {
        formData: {},
        status1: true,
        status2: true,
        selectOptions: {
          province: provinceData,
          city: [],
          barangay: [],
        },
      }
    },
    watch: {
      'formData.province': function(val) {
        if (!this.status1) {
          this.$set(this.formData, 'city', '')
        } else {
          this.status1 = false
        }
        this.selectOptions.city = val ? cityData[val] : []
      },
      'formData.city':function(val) {
        if (!this.status2) {
          this.$set(this.formData, 'barangay', '')
        } else {
          this.status2 = false
        }
        this.selectOptions.barangay = barangayData[val || ''] || []
      },
      'formData.barangay':function(val) {
        if (this.selectOptions.barangay.length > 0 && val) {
          const data = this.selectOptions.barangay.filter(value => value.value === val)[0].zipCode
          this.$set(this.formData, 'zipCode', data[0])
        } else {
          this.$set(this.formData, 'zipCode', '')
        }
      },
    },
    methods: {
      commitData() {
        this.$refs.appForm.$refs.appForm.validate((valid) => {
          if (valid) {
            const data = this.formatCommitData({...this.formData, sameAasHomeAddress: '1'})
            API.addBdoProcess({
              ...data
            }).then((res) => {
              if (res.success === true) {
                this.toNext();
              }
            });
          }
        });
      },
    }
  }
</script>


<style lang="scss">
.corporation_e {
  .panel-v2.content-area .content {
    padding: 32px 0 22px
  }
  .el-form.NewMerchantCorpE {
    .el-form-item {
      &:nth-child(6) {
        width: 26% !important;
      }
      &:nth-child(7) {
        width: 18% !important;
      }
    }
  }
}
</style>
